import React from 'react';
import ReactDOM from 'react-dom/client';
import '@sagano/file/styles/index.css';
import '@sagano/file/i18n';
import App from '@sagano/file/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
